<div class="if-menu-cabinet">
    <ng-content></ng-content>
</div>